import React, { useState, useEffect, useRef, useCallback } from 'react';
import './navigations.css';
import accessories from '../../assets/img/accessories.webp';
import women from '../../assets/img/baju2.webp';
import men from '../../assets/img/men.jpeg';
import { searchProduct } from '../../redux/actions/product';
import { useDispatch } from 'react-redux';
import logobatikshibori from '../../assets/img/logobatikshibori.png'


const Navigations = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      closeDropdown();
    }
  }, [dropdownRef]);

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDropdownOpen, handleClickOutside]);

  const handleProductClick = (e, payload, path) => {
    e.preventDefault();
    dispatch(searchProduct({ payload }));
    setTimeout(() => {
      window.location.href = path;
    }, 100);
  };


  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logobatikshibori} alt="Logo" />
      </div>
      <button className="hamburger" onClick={toggleMenu}>
        &#9776;
      </button>
      <ul className={`nav-list ${isMenuOpen ? 'open' : ''}`}>
        <li className="nav-item">
          <a href="/" className="nav-link font20 fontRobotto nav-sub-item">We For Ecosystem</a>
        </li>
        <li className="nav-item dropdown" ref={dropdownRef}>
          <div style={{ color: '#27456F' }} className="nav-link font20 fontRobotto nav-sub-item" onClick={toggleDropdown}>
            Product
          </div>
          {isDropdownOpen && (
            <div className="dropdown-content">
              <button className="close-button" onClick={closeDropdown}>×</button>
              <div className="dropdown-section">
                <img src={women} alt="Women Category" className="submenu-image" />
                <div>
                  <h4 className='font20 fontRobotto'>Women</h4>
                  <ul>
                    <li><a href="/product_women" onClick={(e) => handleProductClick(e, 'Tops and Blouses', '/product_women')}>Tops and Blouses</a></li>
                    <li><a href="/product_women" onClick={(e) => handleProductClick(e, 'Dresses', '/product_women')}>Dresses</a></li>
                    <li><a href="/product_women" onClick={(e) => handleProductClick(e, 'Pants and Skirt', '/product_women')}>Pants and Skirt</a></li>
                    <li><a href="/product_women" onClick={(e) => handleProductClick(e, 'Outerwear', '/product_women')}>Outerwear</a></li>
                    <li><a href="/product_women" onClick={(e) => handleProductClick(e, 'Shawls', '/product_women')}>Shawls</a></li>
                    <li><a href="/product_women" onClick={(e) => handleProductClick(e, 'Fabric', '/product_women')}>Fabric</a></li>

                  </ul>
                </div>
              </div>
              <div className="dropdown-section">
                <img src={men} alt="Men Category" className="submenu-image" />
                <div>
                  <h4 className='font20 fontRobotto'>Men</h4>
                  <ul>
                    <li><a href="/product_men" onClick={(e) => handleProductClick(e, "Men's Shirts", '/product_men')}>Men's Shirts</a></li>
                    <li><a href="/product_men" onClick={(e) => handleProductClick(e, 'Pants and Sarung', '/product_men')}>Pants and Sarung</a></li>
                    <li><a href="/product_men" onClick={(e) => handleProductClick(e, 'Outerwear', '/product_men')}>Outerwear</a></li>

                  </ul>
                </div>
              </div>
              <div className="dropdown-section">
                <img src={accessories} alt="Accessories Category" className="submenu-image" />
                <div>
                  <h4 className='font20 fontRobotto'>Accessories</h4>
                  <ul>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Clutch & Purse', '/product_accessories')}>Clutch & Purse</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Tote Bag', '/product_accessories')}>Tote Bag</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Laptop Bag', '/product_accessories')}>Laptop Bag</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Scrunchies', '/product_accessories')}>Scrunchies</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Key Chain', '/product_accessories')}>Key Chain</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Footwear', '/product_accessories')}>Footwear</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Jewelries', '/product_accessories')}>Jewelries</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Home Living', '/product_accessories')}>Home Living</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Pillow Case', '/product_accessories')}>Pillow Case</a></li>
                    <li><a href="/product_accessories" onClick={(e) => handleProductClick(e, 'Table Runner', '/product_accessories')}>Table Runner</a></li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </li>
        <li className="nav-item">
          <div className="nav-link font20 fontRobotto nav-sub-item">Our Value</div>
          <div className="dropdown">
            <div className="dropdown-item">
              <a href="/social_impact">Social Impact</a>
            </div>
            <div className="dropdown-item">
              <a href="/sustainability">Sustainability</a>
            </div>
          </div>
        </li>
        <li className="nav-item">
          <a href="/news" className="nav-link font20 fontRobotto nav-sub-item">News</a>
        </li>
        <li className="nav-item">
          <a href="/contact" className="nav-link font20 fontRobotto nav-sub-item">Contact</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navigations;
